module.exports = "<template>\n       <sio-money-display value.bind=\"value\"></sio-money-display>\n</template>\n";